// src/journey/FigureMatchInJourney.js
import React from "react";
import FigureMatchJourneyView from "./FigureMatchJourneyView";

function FigureMatchInJourney({ questionsCount = 2, onComplete }) {
    return (
        <FigureMatchJourneyView
            gameLength={questionsCount}
            onComplete={onComplete}
        />
    );
}

export default FigureMatchInJourney;